import React from "react";
import { motion } from "framer-motion";

const Partners = () => {
  const partners = [
    "https://paycraftsol.com/wp-content/uploads/2019/04/Untitled-4.jpg",
    "https://img.icons8.com/?size=100&id=68803&format=png&color=000000",
    "https://i.pinimg.com/1200x/3c/8e/e2/3c8ee226bb7eb4620b61ffb9ea8d6ebe.jpg",
    "https://media.designrush.com/inspiration_images/756996/conversions/1-mobile.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGdf5gr7aXXDi54ys87m_dK1RZftVkn4mubw&s",
    "https://images.jdmagicbox.com/v2/comp/mumbai/j7/022pxx22.xx22.170821125442.b8j7/catalogue/naukri-com-online-placement-services-oyx4l.jpg",
    "https://paycraftsol.com/wp-content/uploads/2019/04/hdfc-bank.jpg",
    "https://th.bing.com/th/id/OIP.-ducy53wJ_xAJbqdosmmPwHaE8?rs=1&pid=ImgDetMain",
    "https://www.markuptrend.com/wp-content/uploads/2023/05/hostinger-logo.png",
    "https://brand.linkedin.com/apps/settings/wcm/designs/linkedin/katy/global/clientlibs/resources/img/default-share.png",
  ];

  return (
    <section className="relative py-20 sm:py-24 bg-gradient-to-b from-gray-50 to-white text-gray-900 overflow-hidden partners-section">
      {/* Decorative blur backgrounds */}
      <div className="absolute -top-10 -left-10 w-64 h-64 bg-purple-200/20 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-300/20 rounded-full blur-3xl animate-pulse-slow"></div>

      <div className="container mx-auto text-center px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-800 mb-4"
        >
          Our Partners
        </motion.h2>

        <p className="text-gray-600 mb-10 sm:mb-12 text-sm sm:text-base md:text-lg max-w-xl mx-auto">
          Building strong collaborations with industry-leading organizations.
        </p>

        {/* Scrolling Row */}
        <div className="overflow-hidden w-full relative">
          <motion.div
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              repeat: Infinity,
              duration: 25,
              ease: "linear",
            }}
            className="flex w-max gap-6 sm:gap-8 md:gap-10"
          >
            {partners.concat(partners).map((src, index) => (
              <div
                key={index}
                className="flex items-center justify-center bg-gradient-to-b from-white to-gray-50 border border-gray-200 shadow-md rounded-2xl px-8 py-4 sm:px-10 sm:py-5 md:px-12 md:py-6 transition-transform duration-300 hover:scale-105 hover:shadow-lg min-w-[180px] sm:min-w-[220px] md:min-w-[260px]"
              >
                <img
                  src={src}
                  alt="partner logo"
                  className="h-10 sm:h-14 md:h-16 w-auto object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Animation keyframes */}
      <style>
        {`
          @keyframes pulse-slow {
            0%, 100% { opacity: 0.6; transform: scale(1); }
            50% { opacity: 1; transform: scale(1.05); }
          }
          .animate-pulse-slow {
            animation: pulse-slow 8s ease-in-out infinite;
          }
        `}
      </style>
    </section>
  );
};

export default Partners;
